import {
  Box,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Portal,
  VStack,
} from "@chakra-ui/react";
import { MdErrorOutline } from "react-icons/md";
import { IssueId } from "models/issue";
import { IssueTag } from "features/Issues/Components/IssueTag";
import { useIssueDetailQuery } from "features/Issues/hooks";
import { Heading12 } from "components/Heading";

interface IssueTableIconProps {
  issueIds: IssueId[];
}

function IssueTagWithFetch({ issueId }: { issueId: IssueId }) {
  const { data: issue } = useIssueDetailQuery(issueId);

  if (!issue) {
    return null;
  }

  return <IssueTag issue={issue} />;
}

export default function IssueTableIcon({ issueIds }: IssueTableIconProps) {
  if (!issueIds || issueIds.length === 0) {
    return null;
  }

  return (
    <Popover trigger="hover" placement="bottom">
      <PopoverTrigger>
        <Box display="inline-flex" alignItems="center" cursor="pointer">
          <Icon as={MdErrorOutline} color="statusRed.text" boxSize={5} />
        </Box>
      </PopoverTrigger>
      <Portal>
        <PopoverContent width="auto" maxWidth="300px">
          <PopoverBody>
            <VStack spacing={2} align="stretch">
              <Heading12>Issues</Heading12>
              {issueIds.map((issueId) => (
                <IssueTagWithFetch key={issueId} issueId={issueId} />
              ))}
            </VStack>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
